<template>
  <div
    ref="card"
    :class="[
      'p-c-price l-container',
      {
        touched: isTouched,
        skelet: model.price === 0,
        'no-currency': isNoCurrency,
      },
    ]"
    itemscope=""
    itemprop="offers"
    itemtype="http://schema.org/Offer"
    :data-slot="position"
    :data-url="objToBase64({ url: model.view_url })"
    :data-offer_id="model.id ? model.id : ''"
    :data-block="blockType"
    @touchstart="isTouched = true"
    @mouseover="isTouched = false"
    @click="openQuickView"
  >
    <meta itemprop="availability" content="https://schema.org/InStock" />
    <div class="p-c-price__col-info">
      <div class="p-c-price__image" @click.stop="openQuickView">
        <meta itemprop="image" :content="model.image" />
        <div v-if="model.discount" class="p-c-price__price-percent">
          <UiStickerMonitoring type="percent" :text="model.discount.percent" />
        </div>

        <ui-responsive-image
          v-if="model.type !== 'skeleton'"
          :src="model.image || '/static/images/no-img.svg'"
          :alt="model.name"
          :title="model.name"
          loading="lazy"
          class="p-c-price__img"
          :mobile-sizes="{ width: 128, height: 128 }"
          :desktop-sizes="{ width: 128, height: 128 }"
        />
      </div>
      <div class="p-c-price__col-info-base">
        <div class="p-c-price__des-div">
          <div
            :class="['p-c-price__price', 'l-only-mobile']"
            @click.stop="showModalPromo"
          >
            <meta itemprop="price" :content="String(model.price)" />
            <meta itemprop="priceCurrency" content="RUB" />
            <div @click="copyPromo">
              <lazy-exclusive-promo
                :coupon="exclusivePromoData"
                :copy="alreadyCopyPromo"
                @reset-copy="alreadyCopyPromo = false"
              >
                <template #curshow>
                  <UiStickerMonitoring
                    v-if="isMinPrice || isLessThenAvg"
                    is-click
                    class="p-c-price__minimal"
                    :type="isMinPrice ? 'minimal' : 'percent-monitoring'"
                    :text="isMinPrice ? 0 : model.less_than_avg"
                    @click-sticker="openMonitoringStickerModal"
                  />
                  <div class="p-c-price__price__link l-flex">
                    <ui-currency
                      :value="model.price"
                      class="text-subtitle-price-bold main-price price-m price-position"
                    />
                    <div v-if="model.discount" class="p-c-price__price__sale">
                      <ui-Currency
                        :value="model.discount.price_before"
                        class="body-s-strikethrough currency--old"
                      />
                    </div>
                  </div>
                </template>
              </lazy-exclusive-promo>
            </div>
          </div>
          <div class="p-c-price__description">
            <div class="p-c-price__title-wrap" @click.stop="clickName">
              <ui-cpc-link
                class="p-c-price__title body-m-medium"
                :offer="model"
                :position="position"
                :to="model.click_url"
                itemprop="name"
                itemtype="http://schema.org/name"
                itemscope="itemscope"
                :block-type="blockType"
                :disabled="isPlaceOrder"
              >
                {{ model.name }}
              </ui-cpc-link>
            </div>

            <meta itemprop="description" :content="seoDescription" />
            <div v-if="modification?.length" class="p-c-price_characteristic">
              <template v-for="(mod, index) in modification">
                <div
                  v-if="index < 2"
                  :key="mod.value"
                  class="p-c-price_char_row"
                >
                  <span class="p-c-price_char_name body-m-regular"
                    >{{ mod.name }}:
                  </span>
                  <span class="p-c-price_char_value body-m-regular">{{
                    mod.value
                  }}</span>
                </div>
              </template>
            </div>
            <ClientOnly v-else-if="cardDescription && !isBot">
              <div class="p-c-price_characteristic text-body-s-book">
                <span class="p-c-price_char_description_value">{{
                  cardDescription
                }}</span>
              </div>
            </ClientOnly>
          </div>
          <div class="p-c-price__delivery">
            <ui-delivery-info :model="model" :is-show-shop="false" />
          </div>
        </div>
        <ui-ui-link
          size="medium"
          :font-weight="400"
          icon-after="right"
          :responsive-ico="true"
          @click.stop="openQuickView"
        >
          Описание от магазина
        </ui-ui-link>
        <div v-if="model.price === 0" class="new-line"></div>
        <DebugInfo
          v-if="debugPanel"
          class="debug-promocode debug-row"
          :type="model.type"
          :data="model"
        />
      </div>
    </div>
    <div class="p-c-price__delivery xl-block">
      <ui-delivery-info :model="model" :is-show-shop="false" />
    </div>
    <div class="p-c-price__col-data">
      <div class="logo-wrp">
        <div class="p-c-price__shop-with-rating" @click.stop="">
          <ui-cpc-link
            class="p-c-price__shop"
            :offer="model"
            :position="position"
            :to="model.click_url"
            :block-type="blockType"
            :disabled="isPlaceOrder"
            @send-analytics="sendAnalytic(model.shop_info.id)"
          >
            <span
              v-if="isMobile || !model.shop_info.logo"
              class="p-c-price__shop-name body-m-regular"
            >
              {{ model.shop_info.name }}
            </span>
            <ui-responsive-image
              v-if="!isMobile && model.shop_info.logo"
              :src="model.shop_info.logo"
              :title="model.shop_info.name"
              :alt="model.shop_info.name"
              loading="lazy"
              :mobile-sizes="{ width: 128, height: 128 }"
              :desktop-sizes="{ width: 220, height: 220 }"
            />
          </ui-cpc-link>
          <ui-shop-rating :shop="model" is-offer />
        </div>
        <div
          v-if="model.shop_info && model.shop_info.coupon_count"
          class="sales-wrapper"
          @click.stop="clickPromo"
        >
          <div class="sales-text body-m-regular">
            <UiPIcon class="emoji-fire" name="emoji-fire" />
            Скидки в магазине
          </div>
        </div>
      </div>
      <div class="price-wrapper">
        <div class="p-c-price__price p-c-price__price__more-mobile">
          <meta itemprop="price" :content="String(model.price)" />
          <meta itemprop="priceCurrency" content="RUB" />
          <UiStickerMonitoring
            v-if="isMinPrice || isLessThenAvg"
            class="p-c-price__minimal"
            is-click
            :type="isMinPrice ? 'minimal' : 'percent-monitoring'"
            :text="isMinPrice ? 0 : model.less_than_avg"
            @click-sticker="$emit('openMonitoringStickerModal')"
          />
          <div class="p-c-price__price-wrap">
            <div @click.stop="copyPromo">
              <lazy-exclusive-promo
                :coupon="exclusivePromoData"
                :copy="alreadyCopyPromo"
                @reset-copy="alreadyCopyPromo = false"
              >
                <template #curshow>
                  <div class="p-c-price__price__link">
                    <ui-currency
                      :value="model.price"
                      class="price-m main-price"
                    >
                    </ui-currency>
                    <div v-if="model.discount" class="p-c-price__price__sale">
                      <ui-Currency
                        :value="model.discount.price_before"
                        class="body-s-strikethrough"
                      >
                      </ui-Currency>
                    </div>
                  </div>
                </template>
              </lazy-exclusive-promo>
            </div>
          </div>
        </div>
        <div class="p-c-price__btn-wrapper" @click.stop="">
          <ui-cpc-link
            v-if="!isPlaceOrder"
            :to="model.click_url"
            font-class="body-m-regular"
            :offer="model"
            :position="position"
            :block-type="blockType"
          >
            <ui-ui-button
              size="medium"
              :resize="true"
              mode="div"
              font-class="body-m-regular"
              icon-after="link-external"
              :loading="model.price === 0"
            >
              В магазин
            </ui-ui-button>
          </ui-cpc-link>
          <ui-ui-button
            v-else
            :resize="true"
            font-class="body-m-regular"
            size="medium"
            @click="openOrderModal(blockType, position)"
          >
            Сделать заказ
          </ui-ui-button>
          <UiIcon
            v-if="model.type === 'offer'"
            size="20"
            stroke="#86888f"
            class="p-c-price__complain"
            name="alert-triangle"
            @click="openComplainModal"
          />
        </div>
      </div>
    </div>
    <ModalsQuickViewOffer
      v-if="isQuickViewOffer"
      :model="model"
      :is-place-order="isPlaceOrder"
      @order="getOrder"
      @close="isQuickViewOffer = false"
    />
    <ModalsComplainModal
      v-if="showComplainModal"
      :offer-id="model.id"
      @close="closeComplainModal"
    />
    <ModalsConfirmModal
      v-if="showConfirmModal"
      title="Спасибо за обращение!"
      custom-class="complain-confirm"
      description="В ближайшее время мы обработаем ваше обращение и примем меры."
      apply-text="Хорошо"
      :on-apply="() => {}"
      @close="showConfirmModal = false"
    />
  </div>
</template>

<script setup lang="ts">
import type { DeliveryOfferModel, ModelOfferItem } from '~/interfaces/api';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import { useAnalyticsStore } from '~/stores/analytics';
import { useGlobalStore } from '~/stores/global';
import { useModalsStore } from '~/stores/modals';
import { objToBase64 } from '~/utils/base64';

const props = defineProps({
  model: {
    type: Object as () => ModelOfferItem,
    required: true,
  },
  position: {
    type: Number,
    default: 1,
  },
  blockType: {
    type: String,
    default: 'model-offers',
  },
  highlightOffer: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['showPromocodeModal', 'openMonitoringStickerModal']);
const exclusivePromoData = computed(() => props.model.shop_info?.coupon || {});
const mediaStore = useMediaQueryStore();
const { $ymClickLogoEvent, $ymGoalEventPromo, $ymAnyEvent } = useNuxtApp();
const analyticsStore = useAnalyticsStore();
const globalStore = useGlobalStore();
const modalsStore = useModalsStore();
const debugPanel = computed(() => globalStore.debugPanel);
const description = computed(() =>
  props.model.modification_attributes.toString().split(',').join(', ')
);
const isBot = computed(() => globalStore.isBot);
const showComplainModal = ref<boolean>(false);
const showConfirmModal = ref<boolean>(false);

const cardDescription = computed(() => {
  return props.model.description;
});
const isQuickViewOffer = ref(false);
const isMobile = computed(() => mediaStore.isEs || mediaStore.isSm);
const showModalPromo = () => {
  clickCopy(exclusivePromoData.value?.promocode || '');
};
const isTouched = ref(false);

const modification = computed(() => {
  if (!props.model.modification_attributes_desc) return [];
  const attributes_desc: { value: string; name: string }[] = JSON.parse(
    JSON.stringify(props.model.modification_attributes_desc)
  );
  const { first, others } = attributes_desc.reduce(
    (acc, item) => {
      if (item.name === 'Цвет') {
        acc.first.push(item);
      } else {
        acc.others.push(item);
      }
      return acc;
    },
    { first: [], others: [] }
  );
  return [...first, ...others];
});

const card = ref<HTMLElement | undefined>();

const isPlaceOrder = computed(() => props.model?.cpo);
const isMinPrice = computed(() => {
  return props.blockType !== 'model-offers-sale' && props.model?.has_min_price;
});
const isNoCurrency = computed(() => props.blockType === 'model-offers-sale');
const isLessThenAvg = computed(
  () =>
    props.blockType !== 'model-offers-sale' &&
    !isMinPrice.value &&
    !!props.model?.less_than_avg
);
const openOrderModal = (blockType: string, position: number) => {
  modalsStore.setData({
    name: 'order',
    data: {
      offer: props.model,
      position,
      blockType,
    },
  });
};
const getOrder = () => {
  isQuickViewOffer.value = false;
  openOrderModal('pu-offer', 1);
};

function openQuickView() {
  isQuickViewOffer.value = true;
  $ymAnyEvent('reachGoal', 'click_na_opisanie_ot_magazina');
}

const clickName = () => {
  if (isPlaceOrder.value) openQuickView();
};

const openMonitoringStickerModal = () => {
  emit('openMonitoringStickerModal');
};
const openComplainModal = () => {
  showComplainModal.value = true;
  $ymAnyEvent('reachGoal', 'click_button_Complain');
};

const closeComplainModal = (e: string) => {
  showComplainModal.value = false;
  if (e === 'success') {
    showConfirmModal.value = true;
    $ymAnyEvent('reachGoal', 'send_Complaint');
  }
};

const clickPromo = () => {
  emit('showPromocodeModal', props.model.shop_info);
  $ymGoalEventPromo(
    'Promokody v kartochke tovara: click na knopku_skidki v magazine',
    ''
  );
};

const alreadyCopyPromo = ref(false);
const copyPromo = () => {
  alreadyCopyPromo.value = true;
};

const sendAnalytic = (data: number) => {
  $ymClickLogoEvent(data);
};

const seoDescription = computed(() => {
  const strForm = (obj: DeliveryOfferModel) => {
    if (obj?.cost == null) return 'есть';
    return !obj.cost
      ? obj.options && obj.options.length
        ? 'от 0 ₽'
        : 'бесплатно'
      : `${obj.fixed ? '' : 'от '}${obj.cost} ₽`;
  };
  const capitalize = (s: string) => s && s[0].toUpperCase() + s.slice(1);
  const desc = `${props.model.name} в интернет-магазине ${props.model.shop_info.name}. ${description.value}.`;
  const delivery: Array<string> = [];
  if (props.model.pickup) {
    delivery.push('самовывоз ' + strForm(props.model.pickup));
  }
  if (props.model.delivery) {
    delivery.push('доставка ' + strForm(props.model.delivery));
  }
  return [desc, capitalize(delivery.join(', '))].join(' ');
});

onMounted(() => {
  nextTick(() => {
    if (card.value) analyticsStore.observeView(card.value);
    if (card.value && props.highlightOffer) {
      card.value?.classList.add('highlight-offer');
    }
  });
});

onBeforeUnmount(() => {
  if (card.value) analyticsStore.unobserveView(card.value);
});
const copy = ref<boolean>(true);
const clickCopy = async (promo: string) => {
  if (window && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(promo);
      copy.value = false;
    } catch (e) {}
  }
};
</script>
<style scoped lang="scss" src="./ProductCardPriceScss.scss" />
